import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-box" }
const _hoisted_2 = { class: "chart-top" }
const _hoisted_3 = { class: "chart-top-lt" }
const _hoisted_4 = { class: "chart-top-rt" }
const _hoisted_5 = { class: "issues--radio" }
const _hoisted_6 = {
  for: "createdIssuesRadio",
  class: "css-label"
}
const _hoisted_7 = {
  for: "resolvedIssuesRadio",
  class: "css-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.constants.PROJECTS_TEXT), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _cache[0] || (_cache[0] = _createElementVNode("input", {
                type: "radio",
                name: "radiog_download",
                id: "createdIssuesRadio",
                class: "css-checkbox"
              }, null, -1)),
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.constants.CREATED_ISSUES_BUTTON), 1)
            ]),
            _createElementVNode("li", null, [
              _cache[1] || (_cache[1] = _createElementVNode("input", {
                type: "radio",
                name: "radiog_download",
                id: "resolvedIssuesRadio",
                checked: "true",
                class: "css-checkbox"
              }, null, -1)),
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.constants.RESOLVED_ISSUES_BUTTON), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}